const strings = {
  dynamicCallerIdTooltip:
    'If available, a number with the same area code as the customer will be used.',
} as const;

export default strings;
